/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputSuspiciousUserEvent
 */
export interface InputSuspiciousUserEvent {
    /**
     * 
     * @type {string}
     * @memberof InputSuspiciousUserEvent
     */
    capturedText?: string;
    /**
     * 
     * @type {string}
     * @memberof InputSuspiciousUserEvent
     */
    eventType: InputSuspiciousUserEventEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InputSuspiciousUserEvent
     */
    pageUrl: string;
}


/**
 * @export
 */
export const InputSuspiciousUserEventEventTypeEnum = {
    Copy: 'copy',
    Cut: 'cut',
    Selection: 'selection',
    Contextmenu: 'contextmenu',
    Selectall: 'selectall',
    Printscreen: 'printscreen'
} as const;
export type InputSuspiciousUserEventEventTypeEnum = typeof InputSuspiciousUserEventEventTypeEnum[keyof typeof InputSuspiciousUserEventEventTypeEnum];


/**
 * Check if a given object implements the InputSuspiciousUserEvent interface.
 */
export function instanceOfInputSuspiciousUserEvent(value: object): boolean {
    if (!('eventType' in value)) return false;
    if (!('pageUrl' in value)) return false;
    return true;
}

export function InputSuspiciousUserEventFromJSON(json: any): InputSuspiciousUserEvent {
    return InputSuspiciousUserEventFromJSONTyped(json, false);
}

export function InputSuspiciousUserEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputSuspiciousUserEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'capturedText': json['capturedText'] == null ? undefined : json['capturedText'],
        'eventType': json['eventType'],
        'pageUrl': json['pageUrl'],
    };
}

export function InputSuspiciousUserEventToJSON(value?: InputSuspiciousUserEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'capturedText': value['capturedText'],
        'eventType': value['eventType'],
        'pageUrl': value['pageUrl'],
    };
}

